/**
 * Hairline separator. A 1px gray-200 rule — the practical equivalent of the
 * design's 0.5px line (sub-pixel heights render unreliably). Used to divide the
 * heading from the body in the application-status card, and between list rows.
 *
 * Pass `className` for spacing (e.g. `my-2`) at the call site.
 */
export function Divider({ className }: { className?: string }) {
  return <div role="separator" className={`h-px bg-gray-200 ${className ?? ''}`} />
}
